import { AppShell, Burger, Group } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useMutation } from "@tanstack/react-query";
import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { logout } from "../../api/auth.js";
import Logo from '../../assets/images/icon.jpg';
import Footer from "./footer/Footer.jsx";
import Header from './header/Header.jsx';
import Navbar from './Navbar.jsx';
import SEO from '../../components/seo/SEO.jsx';
// import { MantineLogo } from '@mantinex/mantine-logo';


// import { AuthContext } from '../contexts/AuthContext';

const LandingPage = () => {
    //   const { user, logout } = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate()
    useLayoutEffect(() => {
        // const cookieToken =  Cookies.get('token');

    }, [])

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false)
        }, 3000);
    }, []);

    const { mutate, isPending } = useMutation({
        mutationFn: logout,
        onSuccess: (response) => {
            navigate("/login", {
                replace: true
            })
        }
    })

    const [opened, { toggle }] = useDisclosure(true);

    // const token = Cookies.get('token');
    // console.log({token});
    //   if (isLoading) {
    //     return <div>Loading...</div>;
    //   }


    return (
        // <div>
        //     <Navbar></Navbar>
        //   <p>Welcome, {user.name}</p>
        //   <Button  loading={isPending} onClick={() => mutate()}>Logout</Button>
        // </div>

        <AppShell
            header={{ height: { base: 60, md: 70, lg: 80 } }}
            navbar={{
                width: { base: 200, md: 300, lg: 300 },
                breakpoint: 'sm',

                collapsed: { mobile: !opened, desktop: !opened },
            }}
            padding="md"


        >
            <SEO

            />

            <AppShell.Header>


                <Group h="100%" px="md" justify='space-between'>
                    <Group> <Burger opened={opened} onClick={toggle} size="sm" />
                        <img src={Logo} height="60px" width="60px" /></Group>
                    <Header />
                </Group>
            </AppShell.Header>
            <AppShell.Navbar

            >

                <Navbar />

            </AppShell.Navbar>
            <AppShell.Main>
                <Outlet />
            </AppShell.Main>
            <Footer />
        </AppShell>
    );
};

export default LandingPage;
